module.exports = {
  siteTitle:
    'Megha Pathak - React Developer, Open Source Contributor, Product Management Enthusiast  | Megha Pathak',
  siteDescription:
    'Megha Pathak is a curiosity-driven, Product-minded Developer passionate about envisioning and developing great products.',
  siteKeywords:
    'Megha Pathak, Megha, Pathak, Megha LinkedIn, software engineer, front end engineer, web developer, javascript, react developer, open source developer, developer, product manager',
  siteUrl: 'http://meghapathak.tech',
  siteLanguage: 'en_US',

  name: 'Megha Pathak',
  location: 'Jaipur, IND',
  email: 'meghapathak2013@gmail.com',
  github: 'https://github.com/megha-pathak',
  socialMedia: [
    {
      name: 'Github',
      url: 'https://github.com/megha-pathak',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/megha--pathak',
    },
    {
      name: 'Medium',
      url: 'https://medium.com/@meghapathak2013',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/megha.pathak_/',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/Megha_Pathak_',
    },
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/megha.pathak.52056',
    },
  ],

  navLinks: [
    {
      name: 'My Story',
      url: '#about',
    },
    {
      name: 'Portfolio',
      url: '#portfolio',
    },
    {
      name: 'Experience',
      url: '#jobs',
    },

    {
      name: 'Blog',
      url: '#blog',
    },
    {
      name: 'Talks',
      url: '#talks',
    },

    {
      name: 'Contact',
      url: '#contact',
    },
  ],

  twitterHandle: '@Megha_Pathak_',
  googleAnalyticsID: 'UA-143862827-2',

  navHeight: 100,

  greenColor: '#64ffda',
  navyColor: '#0a192f',
  darkNavyColor: '#020c1b',

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
